module.exports = __webpack_public_path__ + "static/media/trip_select.b7c83806.svg";